import { getLocale } from "../runtime";

const sv_whereareyoushoppingfrom = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Var handlar du från?`
};

const whereareyoushoppingfrom = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_whereareyoushoppingfrom(inputs)
	return "whereAreYouShoppingFrom";
};

export { whereareyoushoppingfrom as "whereAreYouShoppingFrom" };